import React, {useRef, useEffect} from 'react';
import {useSelector} from 'react-redux';

import * as S from './GoSafeSlider.styles';
import {FlexCentered} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
// import GoSafeLogoIcon from '../../../../../stories/Icons/GoSafeLogoIcon';
import GoSafeSheildLogo from '../../../../../stories/Icons/goSafeSheildLogo';
import RightArrowNewIcon from '../../../../../stories/Icons/ArrowRightNew';
import useCarousel from '../../../../hooks/useCarousel';
import RightArrowNewIconHome from '../../../../../stories/Icons/ArrowRightNew';
import LeftArrowNewIcon from '../../../../../stories/Icons/ArrowLeftNew';
import {goSafeSegmentDataSelectorFn} from '../../selectors/index';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
const introData = {
  at: {
    title: 'Introducing goSafe',
    para: 'Safe and hygienic places to stay for your upcoming trips',
    showShield: true,
  },
};
const GoSafeSliderUI: React.FC<{
  data: Array<{
    at: {
      sub_title1?: string;
      sub_title2?: string;
      sub_title3?: string;
      sub_title4?: string;
      title: string;
      icon: string;
    };
  }>;
  title: string;
  titleColor?: string;
  footerText?: string;
  footerColor?: string;
  godata?: {
    url?: string;
  };
  persuationTitle: string;
  logo: string;
}> = ({
  data,
  title,
  titleColor,
  footerText,
  footerColor,
  godata = {url: ''},
  persuationTitle,
  logo,
}) => {
  const {increment, decrement, isLeftCursorActive, isRightCursorActive, dataList} = useCarousel(
    data,
    4,
  );
  return (
    <S.GoSafeSliderContainerWrap id={detailsNavigationIds.goSafe}>
      <S.GoSafeSliderHeaderWrapper>
        <FlexCentered>
          <S.GosafeImg src={logo || 'https://gos3.ibcdn.com/gosafesrpnew-1591954890.png'} />
          {/* <S.TextContentBoldSpan>Audited by Deloitte </S.TextContentBoldSpan> */}
          <S.TextContentNormalSpan
            dangerouslySetInnerHTML={{
              __html: persuationTitle,
            }}
          />
        </FlexCentered>

        {/* <S.GoSafeLogoImg src={appConfig.goSafeDefaultLogo} /> */}
        {/* <S.GoSafeSliderTitle customColor={titleColor}>{title}</S.GoSafeSliderTitle> */}
        {(!!godata?.url && !!footerText && (
          <S.GoSafeSliderHeaderBtn href={godata.url} target="_blank" customColor={footerColor}>
            {footerText} <RightArrowNewIcon width="1rem" height="1rem" />
          </S.GoSafeSliderHeaderBtn>
        )) ||
          null}
      </S.GoSafeSliderHeaderWrapper>
      <S.GoSafeSliderList>
        {dataList.map(
          ({
            at: {
              sub_title1 = '',
              sub_title2 = '',
              sub_title3 = '',
              sub_title4 = '',
              title = '',
              icon = '',
              para = '',
              showShield = false,
            },
          }) => (
            <li>
              <S.GoSafeSliderListHeader>
                {icon && (
                  <>
                    <S.GoSafeLogoImg src={icon} width="3rem" />

                    {/* <S.GoSafeLogoBg /> */}
                  </>
                )}
                <S.GoSafeSliderListHeaderText>{title}</S.GoSafeSliderListHeaderText>
              </S.GoSafeSliderListHeader>

              {(!!para && (
                <S.GoSafeSliderItemParaWrap>
                  <S.GoSafeSliderItemParaText>{para}</S.GoSafeSliderItemParaText>
                  {showShield && <GoSafeSheildLogo width="5rem" height="5rem" />}
                </S.GoSafeSliderItemParaWrap>
              )) || (
                <S.GoSafeSliderItemWrap>
                  {!!sub_title1 && <li>{sub_title1}</li>}
                  {!!sub_title2 && <li>{sub_title2}</li>}
                  {!!sub_title3 && (
                    <li>
                      {sub_title3}
                      {/* {sub_title4 && (
                        <S.GoSafeSliderItemMoreWrap>
                          <S.GoSafeSliderItemMoreText>...more</S.GoSafeSliderItemMoreText>
                          <S.GoSafeSliderItemMoreList>
                            <li>{sub_title4}</li>
                          </S.GoSafeSliderItemMoreList>
                        </S.GoSafeSliderItemMoreWrap>
                      )} */}
                    </li>
                  )}
                  {!!sub_title4 && <li>{sub_title4}</li>}
                </S.GoSafeSliderItemWrap>
              )}
            </li>
          ),
        )}
        {!!isRightCursorActive && (
          <S.SliderArrowRight
            onClick={() => {
              increment();
            }}
          >
            <RightArrowNewIconHome />
          </S.SliderArrowRight>
        )}

        {!!isLeftCursorActive && (
          <S.SliderArrowLeft
            onClick={() => {
              decrement();
            }}
          >
            <LeftArrowNewIcon />
          </S.SliderArrowLeft>
        )}
        {/* <li>
          <S.GoSafeSliderListHeader>
            <S.GoSafeListItemLogo src="https://gos3.ibcdn.com/dh_gosafe_sanitizedindoors-1588088839.png" />
            <S.GoSafeLogoBg></S.GoSafeLogoBg>
            <S.GoSafeSliderListHeaderText>Sanitized Environment</S.GoSafeSliderListHeaderText>
          </S.GoSafeSliderListHeader>
          <S.GoSafeSliderItemWrap>
            <li>Hand sanitizer in room</li>
            <li>Liquid soap dispenser</li>
            <li>
              Disposable plates
              <S.GoSafeSliderItemMoreWrap>
                <S.GoSafeSliderItemMoreText>+more</S.GoSafeSliderItemMoreText>
                <S.GoSafeSliderItemMoreList>
                  <li>Social Distancing Maintained</li>
                  <li>Hygenic Rooms</li>
                </S.GoSafeSliderItemMoreList>
              </S.GoSafeSliderItemMoreWrap>
            </li>
          </S.GoSafeSliderItemWrap>
        </li>
        <li>
          <S.GoSafeSliderListHeader>
            <S.GoSafeListItemLogo src="https://gos3.ibcdn.com/dh_gosafe_sanitizedindoors-1588088839.png" />
            <S.GoSafeLogoBg></S.GoSafeLogoBg>
            <S.GoSafeSliderListHeaderText>Trained Staff</S.GoSafeSliderListHeaderText>
          </S.GoSafeSliderListHeader>
          <S.GoSafeSliderItemWrap>
            <li>Daily sanitisation</li>
            <li>Temp check twice a day</li>
            <li>No-touch elevators</li>
          </S.GoSafeSliderItemWrap>
        </li>
        <li>
          <S.GoSafeSliderListHeader>
            <S.GoSafeListItemLogo src="https://gos3.ibcdn.com/dh_gosafe_sanitizedindoors-1588088839.png" />
            <S.GoSafeLogoBg></S.GoSafeLogoBg>
            <S.GoSafeSliderListHeaderText>Safe Practices</S.GoSafeSliderListHeaderText>
          </S.GoSafeSliderListHeader>
          <S.GoSafeSliderItemWrap>
            <li>Staff wear mask all times</li>
            <li>Temp check twice a day</li>
            <li>Social distancing all times</li>
          </S.GoSafeSliderItemWrap>
        </li> */}
        {/* <li>
          <S.GoSafeSliderListHeader>
            <S.SanitisedEnvironmentLogoWrap />
            <S.GoSafeLogoBg></S.GoSafeLogoBg>
            <S.GoSafeSliderListHeaderText>Sanitized Environment</S.GoSafeSliderListHeaderText>
          </S.GoSafeSliderListHeader>
          <S.GoSafeSliderItemWrap>
            <li>Hand sanitizer in room</li>
            <li>Liquid soap dispenser</li>
            <li>Disposable plates</li>
          </S.GoSafeSliderItemWrap>
        </li> */}
      </S.GoSafeSliderList>
    </S.GoSafeSliderContainerWrap>
  );
};

const GoSafeSlider = () => {
  const {cards = [], ...restData} = useSelector(goSafeSegmentDataSelectorFn);

  const goSafeSegmentDataRef = useRef([introData, ...cards]);

  useEffect(() => {
    goSafeSegmentDataRef.current = [introData, ...cards];
  }, [cards]);

  if (!cards.length) return null;

  return <GoSafeSliderUI data={goSafeSegmentDataRef.current} {...restData} />;
};
export default GoSafeSlider;
